import produce from "immer";
import React, { FC } from "react";
import { useDispatch, useSelector } from "react-redux";
import { uuid } from "uuidv4";
import { startEditRow, startRemoveRow } from "../../../actions/rowListAction";
import {
  startAddSection,
  startRemoveSection,
  startEditSection,
} from "../../../actions/sectionListAction";
import { startEditSession } from "../../../actions/sessionListAction";
import { Row } from "../../../models/rowModel";
import { Section } from "../../../models/sectionModel";
import { getSession } from "../../../selectors/appSelectors";
import { getAllDependentsByRowId } from "../../../selectors/rowListSelector";
import { getAllSections } from "../../../selectors/sectionListSelector";
import {
  ResponsiveCol,
  rowHorizontalAlign,
  rowVerticleAlign,
} from "../../../utils/constants";
import Switch from "react-switch";
import { toast } from "react-toastify";
import "./rowProperties.scss";
import { AiOutlineLaptop, AiFillFileAdd } from "react-icons/ai";
import { GoDeviceMobile, GoDeviceDesktop } from "react-icons/go";
import { FaTabletAlt } from "react-icons/fa";
import { Tooltip } from "react-tippy";
import { cssStyle } from "../../../models/cssStyleModel";
import chamalCasingCss from "../common/commonPropertyUtil/chamalCasingCss";
import { Accordion, Button, Card } from "react-bootstrap";
export interface RowPropertiesProps {
  row: Row;
}

const RowProperties: FC<RowPropertiesProps> = ({ row }) => {
  const dispatch = useDispatch();
  const sessionState = useSelector(getSession);
  const sectionState = useSelector(getAllSections);
  const dependentStateForRow = useSelector(getAllDependentsByRowId(row.id));
  const addNewSection = () => {
    dispatch(
      startAddSection({
        rowId: row.id,
        formId: row.formId,
        sortKey: 0,
        tempHiglight: true,
        sectionRowVerticalAlignment: "",
        sectionRowHorizontalAlignment: "",
        inline: false,
        responsiveXs: 0,
        responsiveMd: 0,
        responsiveLg: 0,
        responsiveSm: 0,
        cssStyles: [{}],
        createdTime: "",
        lastUpdatedTime: "",
      })
    );
  };

  const editSectionTempHiglight = (section: Section) => {
    const newSection = produce(section, (draft) => {
      draft.tempHiglight = !draft.tempHiglight;
    });
    dispatch(startEditSection(newSection));
  };

  const errorValidation = () => {
    toast.error("Size Should Be Less Than 12", {
      position: toast.POSITION.TOP_RIGHT,
    });
  };

  // row custome css Add and Remove methods -- start
  const addNewCssStyle = () => {
    let newCssStyle: cssStyle = {
      id: uuid(),
      style: "",
      retrivedStyle: "",
      value: "",
    };
    const newRow = produce(row, (draft) => {
      draft.cssStyles.push(newCssStyle);
    });
    dispatch(startEditRow(newRow));
  };

  const removeCssStyle = (index: number) => {
    const newRow = produce(row, (draft) => {
      draft.cssStyles.splice(index, 1);
    });
    dispatch(startEditRow(newRow));
  };
  // row custome css Add and Remove methods -- end

  const renderSectionList = () => {
    let sectionList = sectionState.filter(
      (section) => section.rowId === row.id
    );
    return sectionList.map((section, i) => {
      let sectionid = uuid();
      let propId = uuid();
      let propertyId = "#" + propId;

      // section custome css Add and Remove methods -- start
      const addNewCssStyleSection = () => {
        let newCssStyle: cssStyle = {
          id: uuid(),
          style: "",
          retrivedStyle: "",
          value: "",
        };
        const newSection = produce(section, (draft) => {
          draft.cssStyles.push(newCssStyle);
        });
        dispatch(startEditSection(newSection));
      };

      const removeCssStyleSection = (index: number) => {
        const newSection = produce(section, (draft) => {
          draft.cssStyles.splice(index, 1);
        });
        dispatch(startEditSection(newSection));
      };
      // section custome css Add and Remove methods -- end
      return (
        <div className="card theam-component">
          <div id={sectionid}>
            <h5 className="mb-0">
              <button
                className="btn btn-dark btn-block theam-font theam-component collapsed"
                data-toggle="collapse"
                data-target={propertyId}
                aria-expanded="false"
                aria-controls={propId}
              >
                Section {i + 1}
              </button>
            </h5>
          </div>
          <div id={propId} className="collapse" aria-labelledby={sectionid}>
            <div
              className="card-body theam-btn border-for-card-body"
              style={{ border: "1px solid #222222" }}
            >
              <div className="form-group row align-items-center mt-3">
                <label
                  htmlFor="Margine-row"
                  className="col-sm-5 col-form-label font-size-12 align-text-left"
                >
                  Row Margine
                </label>
                <div className="col-sm-2">
                  <Switch
                    checked={section.tempHiglight}
                    onChange={() => {
                      editSectionTempHiglight(section);
                    }}
                    onColor="#86d3ff"
                    onHandleColor="#2693e6"
                    handleDiameter={15}
                    uncheckedIcon={false}
                    checkedIcon={false}
                    boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                    activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                    height={10}
                    width={24}
                    className="react-switch"
                    id="Margine-row"
                  />
                </div>
              </div>
              <hr />
              <div className="row align-items-center">
                <div className="col">
                  <Tooltip title="Extra Small Screen">
                    <GoDeviceMobile size={25} />
                  </Tooltip>
                </div>
                <div className="col">
                  <Tooltip title="Small Screen">
                    <FaTabletAlt size={25} />
                  </Tooltip>
                </div>
                <div className="col">
                  <Tooltip title="Medium Screen">
                    <AiOutlineLaptop size={25} />
                  </Tooltip>
                </div>
                <div className="col">
                  <Tooltip title="Large Screen">
                    <GoDeviceDesktop size={25} />
                  </Tooltip>
                </div>
              </div>
              <div className="row align-items-center">
                <div className="col remove-left-right-padding mr-2">
                  <input
                    value={section.responsiveXs}
                    min="0"
                    max="12"
                    className="form-control theam-textbox"
                    onChange={(e) => {
                      if (
                        (parseInt(e.target.value) <= 12 &&
                          parseInt(e.target.value) >= 0) || e.target.value == ""
                      ) {
                        const newSection = produce(section, (draft) => {
                          draft.responsiveXs = parseInt(e.target.value);
                        });
                        dispatch(startEditSection(newSection));
                      } else {
                        errorValidation();
                      }
                    }}
                    type="number"
                    id="section-size-xs"
                  />
                </div>
                <div className="col remove-left-right-padding mr-2">
                  <input
                    value={section.responsiveSm}
                    min="0"
                    max="12"
                    className="form-control theam-textbox"
                    onChange={(e) => {
                      if (
                        (parseInt(e.target.value) <= 12 &&
                          parseInt(e.target.value) >= 0) || e.target.value == ""
                      ) {
                        const newSection = produce(section, (draft) => {
                          draft.responsiveSm = parseInt(e.target.value);
                        });
                        dispatch(startEditSection(newSection));
                      } else {
                        errorValidation();
                      }
                    }}
                    type="number"
                    id="section-size-sm"
                  />
                </div>
                <div className="col remove-left-right-padding mr-2">
                  <input
                    value={section.responsiveMd}
                    min="0"
                    max="12"
                    className="form-control theam-textbox"
                    onChange={(e) => {
                      if (
                        (parseInt(e.target.value) <= 12 &&
                          parseInt(e.target.value) >= 0) || e.target.value == ""
                      ) {
                        const newSection = produce(section, (draft) => {
                          draft.responsiveMd = parseInt(e.target.value);
                        });
                        dispatch(startEditSection(newSection));
                      } else {
                        errorValidation();
                      }
                    }}
                    type="number"
                    id="section-size-md"
                  />
                </div>
                <div className="col remove-left-right-padding">
                  <input
                    value={section.responsiveLg}
                    min="0"
                    max="12"
                    className="form-control theam-textbox"
                    onChange={(e) => {
                      if (
                        (parseInt(e.target.value) <= 12 &&
                          parseInt(e.target.value) >= 0) || e.target.value == ""
                      ) {
                        const newSection = produce(section, (draft) => {
                          draft.responsiveLg = parseInt(e.target.value);
                        });
                        dispatch(startEditSection(newSection));
                      } else {
                        errorValidation();
                      }
                    }}
                    type="number"
                    id="section-size-lg"
                  />
                </div>
              </div>
              <br />
              <div className="form-group row">
                <label
                  htmlFor="field-disabled"
                  className="col-sm-5 col-form-label font-size-12 align-text-left"
                >
                  Inline
                </label>
                <div className="col-sm-2 mt-1">
                  <Switch
                    checked={section.inline}
                    onChange={() => {
                      const newSection = produce(section, (draft) => {
                        draft.inline = !draft.inline;
                      });
                      dispatch(startEditSection(newSection));
                    }}
                    onColor="#86d3ff"
                    onHandleColor="#2693e6"
                    handleDiameter={15}
                    uncheckedIcon={false}
                    checkedIcon={false}
                    boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                    activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                    height={10}
                    width={24}
                    className="react-switch"
                    id="field-disabled"
                  />
                </div>
              </div>
              <div className="form-group row">
                <label
                  htmlFor="section-Vertical-align"
                  className={`col-sm-5 col-form-label font-size-12 align-text-left ${!section.inline ? "disabled-text" : ""}`}
                >
                  Vertical Alignment
                </label>
                <div className="col-sm-7 ">
                  <select
                    value={section.sectionRowVerticalAlignment}
                    id="section-Vertical-align"
                    className={`form-control theam-textbox ${!section.inline ? "disabled-dropdown" : ""}`}
                    disabled={!section.inline}
                    onChange={(e) => {
                      const newSection = produce(section, (draft) => {
                        draft.sectionRowVerticalAlignment = e.target.value;
                      });
                      dispatch(startEditSection(newSection));
                    }}
                  >
                    {rowVerticleAlign.map((item, i) => {
                      return (
                        <option key={i} value={item.value}>
                          {item.name}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </div>
              <div className="form-group row">
                <label
                  htmlFor="section-Vertical-align"
                  className={`col-sm-5 col-form-label font-size-12 align-text-left ${!section.inline ? "disabled-text" : ""}`}
                >
                  Horizontal Alignment
                </label>
                <div className="col-sm-7 ">
                  <select
                    value={section.sectionRowHorizontalAlignment}
                    id="section-Vertical-align"
                    className={`form-control theam-textbox ${!section.inline ? "disabled-dropdown" : ""}`}
                    disabled={!section.inline}
                    onChange={(e) => {
                      const newSection = produce(section, (draft) => {
                        draft.sectionRowHorizontalAlignment = e.target.value;
                      });
                      dispatch(startEditSection(newSection));
                    }}
                  >
                    {rowHorizontalAlign.map((item, i) => {
                      return (
                        <option key={i} value={item.value}>
                          {item.name}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </div>
              <Accordion key={i}>
                <Card className="theam-component">
                  <Accordion.Toggle
                    as={Button}
                    variant="outline-dark"
                    className="theam-font align-text-left"
                    eventKey={`section-${i}`}
                  >
                    <div className="row">
                      <div className="col-sm-10">
                        {`Section ${i + 1} Advaced Styles`}
                      </div>
                      <div className="col-sm-2">
                        <i className="fa fa-plus" onClick={(e) => {
                          e.stopPropagation();
                          addNewCssStyleSection();
                        }}></i>
                      </div>
                    </div>
                  </Accordion.Toggle>
                  <Accordion.Collapse eventKey={`section-${i}`}>
                    <Card.Body className="widh-a theam-btn pt-0" style={{ border: "1px solid #222222" }}>
                      {section.cssStyles.map((_style: cssStyle, a: number) => {
                        return (
                          <div key={a} className="border-bottom pt-3">
                            <div className="form-group row">
                              <div className="col-sm-10"></div>
                              <div className="col-sm-2">
                                <button
                                  type="button"
                                  className="btn btn-dark btn-sm font-size-12"
                                  onClick={(e) => removeCssStyleSection(a)}
                                >
                                  <i className="fa fa-minus"></i>
                                </button>
                              </div>
                            </div>
                            <div className="form-group row">
                              <div className="col-sm-5 noPadding">
                                <input
                                  type="text"
                                  className="form-control theam-textbox"
                                  id={`style-section${a}`}
                                  value={_style.style}
                                  placeholder="Css Property"
                                  onChange={(e) => {
                                    const newSection = produce(
                                      section,
                                      (draft) => {
                                        draft.cssStyles[a].style =
                                          e.target.value;
                                        draft.cssStyles[a].retrivedStyle =
                                          chamalCasingCss(e.target.value);
                                      }
                                    );
                                    dispatch(startEditSection(newSection));
                                  }}
                                />
                              </div>
                              <div className="col-sm-1 noPadding">:</div>
                              <div className="col-sm-6 noPadding">
                                <input
                                  type="text"
                                  className="form-control theam-textbox"
                                  id={`value-section${a}`}
                                  value={_style.value}
                                  placeholder="Enter Value"
                                  onChange={(e) => {
                                    const newSection = produce(
                                      section,
                                      (draft) => {
                                        draft.cssStyles[a].value =
                                          e.target.value;
                                      }
                                    );
                                    dispatch(startEditSection(newSection));
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>
              </Accordion>
            </div>
          </div>
        </div>
      );
    });
  };

  return (
    <>
      <Accordion defaultActiveKey="0">
        <Card className="theam-component">
          <Accordion.Toggle
            as={Button}
            variant="outline-dark"
            className="theam-font align-text-left"
            eventKey="0"
          >
            Rows Properties
          </Accordion.Toggle>

          <Accordion.Collapse eventKey="0">
            <Card.Body className="widh-a theam-btn">
              <div className="form-group row pt-2 pb-2">
                <label
                  htmlFor="row-height"
                  className="col-sm-5 col-form-label font-size-12 align-text-left"
                >
                  Height
                </label>
                <div className="col-sm-6">
                  <input
                    value={row.height}
                    className="form-control theam-textbox "
                    onChange={(e) => {
                      const newRowElement = produce(row, (draft) => {
                        draft.height = e.target.value;
                      });
                      dispatch(startEditRow(newRowElement));
                    }}
                    type="text"
                    id="row-height"
                  />
                </div>
                <span className="ml-1 font-size-12">px</span>
              </div>
              {/* <div className="form-group row">
       <label htmlFor="row-width" className="col-sm-5 col-form-label font-size-12 align-text-left">
         Width
       </label>
         <div className="col-sm-6">
           <input
             value={row.width}
             className="form-control"
             onChange={(e) => {
               const newRowElement = produce(row, draft => { draft.width = e.target.value})
               dispatch(startEditRow(newRowElement));
             }}
             type="text"
             id="row-width"
           />
         </div>
         <span className="ml-1 font-size-12">px</span>
     </div> */}
              <div className="form-group row">
                <label
                  htmlFor="Vertical-align"
                  className="col-sm-5 col-form-label font-size-12 align-text-left"
                >
                  Vertical Alignment
                </label>
                <div className="col-sm-6">
                  <select
                    value={row.verticalAlign}
                    id="Vertical-align"
                    className="form-control theam-textbox"
                    onChange={(e) => {
                      const newRowElement = produce(row, (draft) => {
                        draft.verticalAlign = e.target.value;
                      });
                      dispatch(startEditRow(newRowElement));
                    }}
                  >
                    {rowVerticleAlign.map((item, i) => {
                      return (
                        <option key={i} value={item.value}>
                          {item.name}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </div>
              <div className="form-group row">
                <label
                  htmlFor="Horizontal-align"
                  className="col-sm-5 col-form-label font-size-12 align-text-left"
                >
                  Horizontal Alignment
                </label>
                <div className="col-sm-6">
                  <select
                    value={row.horizontalAlign}
                    id="Horizontal-align"
                    className="form-control theam-textbox"
                    onChange={(e) => {
                      const newRowElement = produce(row, (draft) => {
                        draft.horizontalAlign = e.target.value;
                      });
                      dispatch(startEditRow(newRowElement));
                    }}
                  >
                    {rowHorizontalAlign.map((item, i) => {
                      return (
                        <option key={i} value={item.value}>
                          {item.name}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </div>
            </Card.Body>
          </Accordion.Collapse>

          <Accordion.Toggle
            as={Button}
            variant="outline-dark"
            className="theam-font"
            eventKey="1"
          >
            <div className="row">
              <div className="col-sm-10 align-text-left">
                Row Advance Styles
              </div>
              <div className="col-sm-2 pl-1 pr-2">
                <i
                  className="fa fa-plus"
                  onClick={(e) => {
                    e.stopPropagation();
                    addNewCssStyle();
                  }}
                ></i>
              </div>
            </div>
          </Accordion.Toggle>

          <Accordion.Collapse eventKey="1">
            <Card.Body className="widh-a theam-btn pt-0">
              {row.cssStyles.map((_style: cssStyle, i: number) => {
                return (
                  <div key={i} className="border-bottom pt-3">
                    <div className="form-group row">
                      <div className="col-sm-10"></div>
                      <div className="col-sm-2">
                        <button
                          type="button"
                          className="btn btn-dark btn-sm font-size-12"
                          onClick={(e) => removeCssStyle(i)}
                        >
                          <i className="fa fa-minus"></i>
                        </button>
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-sm-5 noPadding">
                        <input
                          type="text"
                          className="form-control theam-textbox"
                          id={`style${i}`}
                          value={_style.style}
                          placeholder="Css Property"
                          onChange={(e) => {
                            const newRow = produce(row, (draft) => {
                              draft.cssStyles[i].style = e.target.value;
                              draft.cssStyles[i].retrivedStyle =
                                chamalCasingCss(e.target.value);
                            });
                            dispatch(startEditRow(newRow));
                          }}
                        />
                      </div>
                      <div className="col-sm-1 noPadding">:</div>
                      <div className="col-sm-6 noPadding">
                        <input
                          type="text"
                          className="form-control theam-textbox"
                          id={`value${i}`}
                          value={_style.value}
                          placeholder="Enter Value"
                          onChange={(e) => {
                            const newRow = produce(row, (draft) => {
                              draft.cssStyles[i].value = e.target.value;
                            });
                            dispatch(startEditRow(newRow));
                          }}
                        />
                      </div>
                    </div>
                  </div>
                );
              })}
            </Card.Body>
          </Accordion.Collapse>
          <Accordion.Toggle
            as={Button}
            variant="outline-dark"
            className="theam-font"
            eventKey="2"
          >
            <div className="row">
              <div className="col-sm-10 align-text-left">Sections</div>
              <div className="col-sm-2">
                <AiFillFileAdd
                  size={20}
                  onClick={(e) => {
                    e.stopPropagation();
                    addNewSection();
                  }}
                />
              </div>
            </div>
          </Accordion.Toggle>

          <Accordion.Collapse eventKey="2">
            <Card.Body className="padding-0 widh-a">
              {renderSectionList()}
            </Card.Body>
          </Accordion.Collapse>
          <Accordion.Toggle
            as={Button}
            variant="outline-dark"
            className="theam-font"
            eventKey="3"
          >
            <div className="row">
              <div className="col-sm-10 align-text-left">Remarks</div>
            </div>
          </Accordion.Toggle>

          <Accordion.Collapse eventKey="3">
            <Card.Body className="padding-0 widh-a">
              <div className="container pt-3 btn-theam pb-2">

                <div className="form-group row">
                  <label htmlFor="remark1" className="col-sm-4 col-form-label font-size-12 align-text-left">
                    Remark - 1
                  </label>
                  <div className="col-sm-8">
                    <input
                      type="text"
                      className="form-control theam-textbox items-align-left"
                      placeholder="Enter Remark"
                      id="remark1"
                      value={row.remark1}
                      onChange={(e) => {
                        const newRowElement = produce(row, (draft) => {
                          draft.remark1 = e.target.value;
                        });
                        dispatch(startEditRow(newRowElement));
                      }}
                    />
                  </div>
                </div>
                <div className="form-group row">
                  <label htmlFor="remark2" className="col-sm-4 col-form-label font-size-12 align-text-left">
                    Remark - 2
                  </label>
                  <div className="col-sm-8">
                    <input
                      type="text"
                      className="form-control theam-textbox items-align-left"
                      placeholder="Enter Remark"
                      id="remark2"
                      value={row.remark2}
                      onChange={(e) => {
                        const newRowElement = produce(row, (draft) => {
                          draft.remark2 = e.target.value;
                        });
                        dispatch(startEditRow(newRowElement));
                      }}
                    />
                  </div>
                </div>
                <div className="form-group row">
                  <label htmlFor="remark3" className="col-sm-4 col-form-label font-size-12 align-text-left">
                    Remark - 3
                  </label>
                  <div className="col-sm-8">
                    <textarea className="form-control theam-textbox font-size-12 items-align-left" name="remark3" id="remark3" placeholder="Enter Remark" cols={30} rows={10}
                      value={row.remark3}
                      onChange={(e) => {
                        const newRowElement = produce(row, (draft) => {
                          draft.remark3 = e.target.value;
                        });
                        dispatch(startEditRow(newRowElement));
                      }}
                    ></textarea>
                  </div>
                </div>
                <div className="form-group row">
                  <label htmlFor="remark4" className="col-sm-4 col-form-label font-size-12 align-text-left">
                    Remark - 4
                  </label>
                  <div className="col-sm-8">
                    <textarea className="form-control theam-textbox font-size-12 items-align-left" name="remark4" id="remark4" placeholder="Enter Remark" cols={30} rows={10}
                      value={row.remark4}
                      onChange={(e) => {
                        const newRowElement = produce(row, (draft) => {
                          draft.remark4 = e.target.value;
                        });
                        dispatch(startEditRow(newRowElement));
                      }}
                    ></textarea>
                  </div>
                </div>
              </div>
            </Card.Body>
          </Accordion.Collapse>
        </Card>
      </Accordion>
    </>
  );
};

export default RowProperties;
